module.exports = __webpack_public_path__ + "34b97b5b357590f62c5ddd130a8dc5d8.png";


//////////////////
// WEBPACK FOOTER
// ./routes/home/tick-black.png
// module id = sfH+
// module chunks = 3